import ExcelLoadingButtonBox from './ExcelLoadingButtonBox';

export const AddButtonBox = ({ title = '추가', onClick }) => {
    return (
        <button type='button' className='btn btn-common submit' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const DownloadButtonBox = ({ title = '샘플 다운로드', onClick }) => {
    return (
        <button type='button' className='btn btn-common download mr10' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const UploadButtonBox = ({ callback }) => {
    return <ExcelLoadingButtonBox callback={callback} />;
};

export const DeleteAllButtonBox = ({ title = '수신자 삭제', onClick }) => {
    return (
        <button type='button' className='btn red-border' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const SendTestButtonBox = ({ title = '테스트 발송', onClick }) => {
    return (
        <button type='button' className='btn blue-border' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const SendButtonBox = ({ title = '발송', onClick }) => {
    return (
        <button type='button' className='btn blue-bg' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};
